<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container">
                <p v-if="!selectedUsers.length">
                    You have to select users that you want to preform actions with!
                </p>
                <div v-else class="custom-control custom-switch main-switch">
                    <div class="form-check form-switch">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            v-model="public"
                            :checked="public"
                        />
                        <p>
                            {{
                                public
                                    ? `de-activate the ${
                                          selectedUsers.length > 1 ? 'users' : 'user'
                                      }: the ${
                                          selectedUsers.length > 1 ? 'profiles' : 'profile'
                                      } will become private`
                                    : `activate the ${
                                          selectedUsers.length > 1 ? 'users' : 'user'
                                      }: the ${
                                          selectedUsers.length > 1 ? 'profiles' : 'profile'
                                      } will become public`
                            }}
                        </p>
                    </div>
                    <button class="btn btn-outline-primary" @click="update">Update</button>
                </div>
                <div class="modal-footer">
                    <slot name="footer">
                        <b-button class="modal-default-button" @click="closeModal">
                            Cancel
                        </b-button>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    const URLS = {
        xhr: {
            mutate: {
                unclaimedProfileUpdate: '/api/admin/artist-profiles/update-unclaimed'
            }
        }
    }
    export default {
        name: 'ModalActions',
        props: {
            activeModal: {
                type: Boolean
            },
            selectedUsers: {
                type: Array
            }
        },
        data: () => ({
            public: false
        }),
        methods: {
            closeModal() {
                this.$emit('close-modal')
            },
            async update() {
                try {
                    await axios.post(`${URLS.xhr.mutate.unclaimedProfileUpdate}`, {
                        selectedUsers: this.selectedUsers.map((user) => user.id),
                        public: this.public
                    })
                } catch (error) {
                    console.error(error)
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: table;
        transition: opacity 0.3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 300px;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        font-family: Instrument Sans, Arial, sans-serif;
    }
    .modal-default-button {
        float: right;
    }
</style>
